/*
 * @Description:
 * @Date: 2021-02-03 14:37:20
 */
import router from '@/router/index';

import {
  queryViewingCheckInfo,
  queryUserInfoAnswer,
  queryLiveShareList,
  getCourseRela,
  queryliveZdyMenuList,
  queryChannelZhiboRaffle,
  queryChannelZhiboConf,
  queryChannelCourse,
  queryLiveShareCourseList,
  queryDrawResults,
  queryCourseRaffleConfigInfo,
  queryCheckZhiboRaffleInfi,
  isZhiboWhite
} from '@/api/course';
import { storageUserInfo } from '@/utils/storage';

/**
 * @description:    判断当前直播状态
 * @param {object}  直播详情
 * @param {object}  直播配置
 * @return {number} 1直播前 2直播中 3直播结束 4转码中 5回放 6视频
 */
const getCurrentLivingStatus = (livingDetail, livingConfig) => {
  let { startDt, videoUrl, isEnd, transUrl } = livingDetail;
  let { isVedio, isReplay } = livingConfig;
  const _startDt = startDt - 60 * 1000 * 10;
  // 直播前
  if (_startDt > Date.now()) {
    return 1;
  } else {
    // 直播结束
    if (isEnd) {
      // 直播结束
      if (!isVedio && !isReplay) {
        return 3;
      }
      // 回放、视频
      if (transUrl) {
        // 回放
        if (isReplay) {
          return 5;
        }
        if (isVedio) {
          return 6;
        }
      } else {
        // 转码中
        if (isVedio || isReplay) {
          return 4;
        }
      }
    } else {
      // 直播中
      if (videoUrl) {
        return 2;
      }
    }
  }
};

const filterResult = (result, defaultType = 'array') => {
  let defaultResult = defaultType === 'array' ? [] : {};
  return result || defaultResult;
};

const state = {
  coverVideo: false, // 是否出现弹层，当有视频播放时需要隐藏播放器
  detail: {}, // 课程详情
  rela: [], // 关联直播
  zdyMenuList: [], // 直播菜单
  checkInfo: {}, // 限制信息
  isSubmitCheck: false, // 是否提交过限制问卷
  currentZdyMenu: {
    // 当前菜单
    type: 100,
    id: 100,
    content: ''
  },
  time: 0,
  isMobile: false, // 是否为手机
  isDesktop: true, // 是否为桌面
  raffle: {}, // 抽奖信息,无id则无抽奖 {id status type viewTime}
  livingConf: {}, // 直播配置信息
  drawResult: {}, // 抽奖结果
  shareList: [], // 邀请卡
  isRaffled: false, // 当前用户是否已抽奖
  raffleList: [], // 奖品数据
  livingStatus: 0, // 1直播前 2直播中 3直播结束 4转码中 5转码完成
  realUsers: 0, // 实时用户数
  totalUsers: 0, // 用户总次数
  whiteStatus: '' // 白名单 1 需要登录 2 无权限 3可以观看
};
const mutations = {
  SET_COMMON(state, data) {
    state[data.field] = data.value;
  },
  /**
   * @description 设置设备类型
   * @param {Object} state vuex state
   * @param {String} type 设备类型，可选值为 Mobile、Tablet、Desktop
   */
  SET_DEVICE(state, type) {
    state.isMobile = false;
    state.isDesktop = false;
    state[`is${type}`] = true;
  },
  SET_TIME(state) {
    state.time++;
    console.log(state.time);
  }
};
const actions = {
  async init({ dispatch, commit }) {
    let courseId = router.currentRoute.params.id;
    await dispatch('setCourseDetail', courseId);
    dispatch('setCourseRela', courseId);
    dispatch('setZdyMenuList', courseId);
    dispatch('setChekInfo', courseId);
    dispatch('setRaffle', courseId);
    // dispatch('setZhiboConf', courseId);
    dispatch('setShareList', courseId);
    await dispatch('setWhite', courseId);
    return Promise.resolve();
  },
  // 课程详情
  async setCourseDetail({ commit }, courseId) {
    return new Promise((resolve, reject) => {
      Promise.all([
        queryChannelCourse({ courseId }),
        queryChannelZhiboConf({ courseId })
      ])
        .then(([courseDetail, courseConf]) => {
          let detail = filterResult(courseDetail.pdata)[0] || {};
          let livingConf = filterResult(courseConf.pdata) || {};
          commit('SET_COMMON', {
            field: 'detail',
            value: detail
          });
          commit('SET_COMMON', {
            field: 'livingConf',
            value: livingConf
          });

          commit('SET_COMMON', {
            field: 'livingStatus',
            value: getCurrentLivingStatus(detail, livingConf)
          });
          resolve();
        })
        .catch(error => reject());
    });
  },
  // 课程关联直播
  async setCourseRela({ commit }, courseId) {
    let {
      pdata: { guanLianList }
    } = await getCourseRela({ courseId });
    commit('SET_COMMON', {
      field: 'rela',
      value: filterResult(guanLianList)
    });
    return Promise.resolve();
  },
  // 直播菜单
  async setZdyMenuList({ commit }, courseId) {
    let { pdata } = await queryliveZdyMenuList({ courseId });
    // 聊天互动 写死
    pdata.unshift({
      name: '聊天互动',
      questionnaireId: null,
      sort: -1,
      type: 100,
      id: 100
    });
    pdata = pdata.sort((a, b) => {
      return a.sort - b.sort;
    });
    commit('SET_COMMON', {
      field: 'zdyMenuList',
      value: pdata
    });
    return Promise.resolve();
  },
  // 检查是否有限制
  async setChekInfo({ commit }, courseId) {
    let { pdata } = await queryViewingCheckInfo({ courseId });
    const info = (pdata && pdata[0]) || {};
    if (info.id && storageUserInfo().id) {
      // 是否答题
      await queryUserInfoAnswer({
        courseId,
        authId: info.id
      }).then(({ pdata: s }) => {
        commit('SET_COMMON', {
          field: 'isSubmitCheck',
          value: (s || []).length > 0
        });
      });
    }
    commit('SET_COMMON', {
      field: 'checkInfo',
      value: info
    });
    return Promise.resolve();
  },
  // 检查是否有白名单
  async setWhite({ commit }, courseId) {
    let { pdata } = await isZhiboWhite({ courseId });
    commit('SET_COMMON', {
      field: 'whiteStatus',
      value: pdata.type //0:允许访问 1:需要登录 2:无权限
    });
    return Promise.resolve();
  },
  // 抽奖信息
  async setRaffle({ commit, rootState }, courseId) {
    // 获取抽奖信息
    let { pdata } = await queryChannelZhiboRaffle({ courseId });
    pdata = filterResult(pdata)[0] || {};
    commit('SET_COMMON', {
      field: 'raffle',
      value: pdata
    });
    if (pdata.id) {
      // 获取奖品信息
      queryCourseRaffleConfigInfo({ raffleId: pdata.id, courseId }).then(
        ({ pdata: raffleList }) => {
          commit('SET_COMMON', {
            field: 'raffleList',
            value: raffleList
          });
        }
      );
      // 获取是否已参与抽奖
      if (rootState.user.info.id) {
        queryCheckZhiboRaffleInfi({
          raffleId: pdata.id,
          userId: rootState.user.info.id
        }).then(({ pdata: isRaffled }) => {
          commit('SET_COMMON', {
            field: 'isRaffled',
            value: isRaffled ? true : false
          });
        });
      } else {
        commit('SET_COMMON', {
          field: 'isRaffled',
          value: false
        });
      }
    }
    return Promise.resolve();
  },
  // 直播配置
  async setZhiboConf({ commit }, courseId) {
    let { pdata } = await queryChannelZhiboConf({ courseId });
    return Promise.resolve();
  },
  // 邀请卡
  async setShareList({ commit }, courseId) {
    let { pdata } = await queryLiveShareList({ courseId });
    commit('SET_COMMON', {
      field: 'shareList',
      value: filterResult(pdata)
    });
    return Promise.resolve();
  },
  // 触发抽奖并判断是否中奖
  async onDraw({ commit, state, rootState }) {
    if (rootState.user.info.id) {
      try {
        let {
          pdata: { code, courseRaffleConfig = {} }
        } = await queryDrawResults({
          courseId: state.detail.id,
          userId: rootState.user.info.id,
          raffleId: state.raffle.id
        });
        courseRaffleConfig.showReceive = code !== '0';
        commit('SET_COMMON', {
          field: 'drawResult',
          value: courseRaffleConfig
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject();
      }
    } else {
      return Promise.reject();
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
